module.exports = __webpack_public_path__ + "static/media/flowers_Thumb_1.11aa4199.jpg";